/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Files/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import FileUploaderDashboard from 'DesignSystem/FileUploaderDashboard/react'
import FileUploaderProvider from 'DesignSystem/FileUploaderProvider/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Files({
  children,
  viewPath = "/App/Account/Content/Settings/Content/DocumentTemplates/Templates/ImportAction/Content/Files",
  restrictions,
  onChange
  
}) {
let importFilesChangeData = fromData.useDataChange({ viewPath,
context: 'import',
path: 'files',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<FileUploaderProvider
  viewPath={`${viewPath}/FileUploaderProvider`}
 reset={true}
 restrictions={restrictions}
 data="import.files"
 onChange={importFilesChangeData}
>
{childProps => (
<FileUploaderDashboard
{...childProps}
  viewPath={`${viewPath}/FileUploaderDashboard`}
 marginTop={dtSpaceS}
 height={500}
 width={740}
 hideUploadButton={true}
 singleFileFullScreen={false}
/>
)}
</FileUploaderProvider>
{children}
</React.Fragment>)
}